import React from "react";
import CommonManagementSection from "./CommonManagementSection";


class StudioSection extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
        }
    }


    render() {
        return (
            <div id='studio' className='lndSolutionEachSec'>
                <div className='lndSoltopHead'>
                    <h3>Studio</h3>
                    <p>A revolutionary tool for content creators to publish Premium content.</p>
                    <p>Environment Professionals, Trainers or Educators can publish content for FREE or PAID for the users.</p>
                </div>
                <div className='specialGridCol'>
                    <CommonManagementSection sectionType={"STUDIO"} />

                    <div className='lndSPCol lndSolRightInfoBlk'>
                        <h4>Breakfree from the restriction on Subscriber Benchmark, Costs, Formats, Promotions, Support Desk</h4>
                        <ul className='lndSolLists'>
                            <li>
                                <figure><img src={"https://cdn.dscovr.com/images/lnsolStudIco-1.svg"} alt='' /></figure>
                                <div>
                                    <h5>Wide range of content formats</h5>
                                    <p>Supports Videos, images, ppt, pdf</p>
                                </div>
                            </li>
                            <li>
                                <figure><img src={"https://cdn.dscovr.com/images/lnsolStudIco-2.svg"} alt='' /></figure>
                                <div>
                                    <h5>Unique Promotional Tools</h5>
                                    <p>Additional promotion content for audience engagement</p>
                                </div>
                            </li>
                            <li>
                                <figure><img src={"https://cdn.dscovr.com/images/lnsolStudIco-3.svg"} alt='' /></figure>
                                <div>
                                    <h5>Your-own Helpdesk</h5>
                                    <p>Create your-own helpdesk for seamless support</p>
                                </div>
                            </li>
                            <li>
                                <figure><img src={"https://cdn.dscovr.com/images/lnsolStudIco-4.svg"} alt='' /></figure>
                                <div>
                                    <h5>No Minimum Benchmark</h5>
                                    <p>You can earn from the first Subscriber at your desired cost.</p>
                                </div>
                            </li>
                            <li>
                                <figure><img src={"https://cdn.dscovr.com/images/lnsolStudIco-5.svg"} alt='' /></figure>
                                <div>
                                    <h5>No Intermediaries</h5>
                                    <p>Receive funds directly in your account</p>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
}

export default StudioSection;